import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ActivityInterface,
  MarginMaxActivityInterface,
} from '../../interfaces/manage-activity-logs.interface';
import { EnvironmentConfig } from '../../../shared/interfaces/environment.interface';

@Injectable({
  providedIn: 'root',
})
export class ManageActivityLogsService {
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;
  private readonly _surveyStatiscticsServiceUrl =
    this._env.environment.pureSpectrum.surveyStatiscticsServiceUrl;

  constructor(
    private _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  getActivityLogsData(surveyId: number | undefined) {
    return this._http.get<ActivityInterface[]>(
      `${this._baseUrl}/activities/v2/surveys/${surveyId}`
    );
  }

  getActivityLogsForMarginMax(surveyId: number) {
    return this._http.get<MarginMaxActivityInterface>(
      `${this._surveyStatiscticsServiceUrl}/surveys/logs/${surveyId}/pace`
    );
  }

  sendHihCpiConfirmation(surveyId: number, newCpi: string | number) {
    const payload = {
      eventSource: 'user',
      logMessage: `Confirmed a high CPI of ${newCpi} on`,
      eventType: 'Alert',
      platform: 'test',
    };
    return this._http.post<any>(
      `${this._baseUrl}/activities/v2/surveys/${surveyId}`,
      payload
    );
  }
}
